export default "__VITE_ASSET__CNhUZG3x__"